/* eslint-disable no-undef */
import axios, { AxiosRequestConfig } from "axios";
// import { getStore } from "../store";
// import { setNotification } from "../store/toastNotificationSlice";
import { jwtDecode } from "jwt-decode";

// Extend AxiosRequestConfig to allow custom property isUserAction
declare module "axios" {
  export interface AxiosRequestConfig {
    isUserAction?: boolean;
  }
}

const tenantId =
  typeof window !== "undefined" ? localStorage.getItem("tenantId") : 2;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Abp.TenantId": `${tenantId}`,
    "x-api-key": process.env.REACT_APP_API_KEY || "",
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    let token = null;

    if (typeof window !== "undefined") {
      token = localStorage.getItem("token");
    }

    if (token) {
      if (isTokenExpired(token)) {
        localStorage.setItem("token", "");
        // const router = useRouter();
        // router.push("/auth/sign-in");
      }
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    //console.log("error " + JSON.stringify(error));
    return Promise.reject(error);
  }
);

// Response interceptor to handle success notifications only for user actions
axiosInstance.interceptors.response.use(
  (response) => {
    const { config } = response;
    // const store = getStore();

    // Check if the request is a mutation and a user-initiated action
    if (config.method && isMutation(config.method.toUpperCase()) && config.isUserAction) {
    //   store.dispatch(
    //     setNotification({
    //       type: "success",
    //       message: "Completed successfully",
    //     })
    //   );
        console.log("Completed successfully");
    }
    return response;
  },
  (error) => {
    // setNotification({
    //   type: "error",
    //   message: error.message,
    // });
    //console.log("error " + JSON.stringify(error));
    return Promise.reject(error);
  }
);

function isTokenExpired(token: string): boolean {
  if (!token) return true; // If no token, consider it as expired

  try {
    // Decode the token to get its payload
    const decodedToken = jwtDecode(token);

    // Get current time in seconds
    const currentTime = Date.now() / 1000;

    // Check if the token has already expired
    if (typeof decodedToken === "object" && decodedToken && "exp" in decodedToken && typeof (decodedToken as any).exp === "number") {
      return (decodedToken as any).exp < currentTime;
    }
    // If exp is not present, consider the token as expired
    return true;
  } catch (error) {
    // In case of any decoding issues, consider the token as expired
    // console.log("Error Decoding JWT " + error);
    return true;
  }
}

const isMutation = (method:string): boolean => {
  const MUTATION_METHODS = ["POST", "PUT", "DELETE"];
  return MUTATION_METHODS.includes(method);
};

/**
 * Custom function for user-initiated requests
 * Example usage:
 * axiosInstance.post("/endpoint", data, { isUserAction: true });
 */
export function userActionPost(url: string, data: any) {
  return axiosInstance.post(url, data, { isUserAction: true });
}

export function userActionPut(url: string, data: any) {
  return axiosInstance.put(url, data, { isUserAction: true });
}

export function userActionDel(url: string, data: AxiosRequestConfig<any> | undefined) {
  const config = { ...data, isUserAction: true };
  return axiosInstance.delete(url, config);
}

export default axiosInstance;
